// extracted by mini-css-extract-plugin
export default {"page":"Imprint_page__MTQNL"};